import {createI18n} from "vue-i18n";
import common from "@/i18n/common";
import btn from "@/i18n/btn";
import sideBar from "@/i18n/sideBar";
import article from "@/i18n/article";
import book from "@/i18n/book";
import exhibition from "@/i18n/exhibition";
import academic from "@/i18n/academic";
import teaching from "@/i18n/teaching";
import service from "@/i18n/service";
import award from "@/i18n/award";
import journal from "@/i18n/journal";
import systemManagement from "@/i18n/systemManagement";
import print from "@/i18n/print";
import notice from "@/i18n/notice";
import codeManagement from "@/i18n/codeManagement";
import personalInfo from "@/i18n/personalInfo";
import evalManagement from "@/i18n/evalManagement";
import logManagement from "@/i18n/logManagement";
import homepage from "@/i18n/homepage";
import user from "@/i18n/user";
import achvmPlan from "@/i18n/achvmPlan";
import judgementTargets from "@/i18n/judgementTargets";
import csJournalModal from "@/i18n/csJournalModal";
import bookGubunModal from "@/i18n/bookGubunModal";
import detailEvaluation from "@/i18n/detailEvaluation";
import statistics from "@/i18n/statistics";

export async function setI18n() {
	// 아래 message는 API 통한 DB 조회후 생성하는 로직 추가 필요
	let messages = {en: {},ko: {}};

	await setMessage(messages, 'common', common);
	await setMessage(messages, 'btn', btn);
	await setMessage(messages, 'article', article);
	await setMessage(messages, 'sideBar', sideBar);
	await setMessage(messages, 'book', book);
	await setMessage(messages, 'exhibition', exhibition);
	await setMessage(messages, 'academic', academic);
	await setMessage(messages,'teaching', teaching);
	await setMessage(messages, 'service', service);
	await setMessage(messages, 'award', award);
	await setMessage(messages, 'journal', journal);
	await setMessage(messages,'systemManagement', systemManagement);
	await setMessage(messages, 'print', print);
	await setMessage(messages, 'notice', notice);
	await setMessage(messages, 'codeManagement', codeManagement);
	await setMessage(messages, 'personalInfo', personalInfo);
	await setMessage(messages, 'evalManagement', evalManagement);
	await setMessage(messages, 'logManagement', logManagement);
	await setMessage(messages, 'homepage', homepage);
	await setMessage(messages, 'user', user);
	await setMessage(messages, 'achvmPlan', achvmPlan);
	await setMessage(messages, 'judgementTargets', judgementTargets);
	await setMessage(messages, 'csJournalModal', csJournalModal);
	await setMessage(messages, 'bookGubunModal', bookGubunModal);
	await setMessage(messages, 'detailEvaluation', detailEvaluation);
	await setMessage(messages, 'statistics', statistics);

	return createI18n({
		locale: 'ko',
		messages
	})
}

async function setMessage(messages, group, message) {
	messages.en[group] = message.en;
	messages.ko[group] = message.ko;
}